"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StateReducer = exports.HandleChange = exports.GetIdMap = exports.ExtractPanelId = exports.DefaultStyles = void 0;
var AccordionMethods = _interopRequireWildcard(require("./Accordion"));
var _Add = _interopRequireDefault(require("@mui/icons-material/Add"));
var _dompurify = _interopRequireDefault(require("dompurify"));
var _common = require("../../config/common");
var _ImportedContentFragment = _interopRequireDefault(require("../ContentFragments/ImportedContentFragment"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Remove = _interopRequireDefault(require("@mui/icons-material/Remove"));
var _classnames = _interopRequireDefault(require("classnames"));
var _array = require("../../utils/type-checks/array");
var _function = require("../../utils/type-checks/function");
var _object = require("../../utils/type-checks/object");
var _string = require("../../utils/type-checks/string");
var _scroll = require("../../utils/scroll");
var _reactRouterDom = require("react-router-dom");
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
require("../../utils/polyfills");
const merge = require("deepmerge"),
  DefaultStyles = theme => {
    return {
      ".MuiAccordion-root": {
        borderBottom: "0.1rem rgba(151, 151, 151, 0.25) solid",
        boxShadow: "unset",
        fontFamily: theme.fontFamilies.default,
        fontSize: theme.typography.fontSize,
        margin: "2.5rem 0 !important",
        ".MuiAccordionSummary-root": {
          backgroundColor: "#FAFAFA",
          minHeight: "4rem",
          padding: "0.8rem 1.6rem",
          "&.Mui-focusVisible": {
            ...theme.mixins.focus,
            color: theme.palette.text.primary,
            outline: "none"
          },
          ".MuiSvgIcon-root": {
            color: theme.palette.primary.main,
            height: "2.2rem",
            transition: "none",
            width: "2.2rem"
          },
          ".MuiAccordionSummary-expandIconWrapper": {
            transition: "none"
          },
          ".MuiAccordionSummary-content": {
            margin: "0 1rem 0 0"
          }
        },
        ".Accordion--isHeader": {
          color: theme.palette.primary.main,
          fontFamily: theme.fontFamilies.semiBold,
          fontSize: "1.8rem",
          textTransform: "uppercase"
        },
        ".Accordion--isDetails": {
          fontSize: "1.6rem"
        }
      }
    };
  },
  ExtractPanelId = obj => {
    let result = null;
    if ((0, _object.isObject)(obj)) {
      if (Object.hasOwn(obj, "linkId") && (0, _string.isStringOfLength)(obj.linkId)) {
        result = obj.linkId;
      } else if (Object.hasOwn(obj, "customId") && (0, _string.isStringOfLength)(obj.customId)) {
        result = obj.customId;
      } else if (Object.hasOwn(obj, "fragmentId") && (0, _string.isStringOfLength)(obj.fragmentId)) {
        result = obj.fragmentId;
      }
    }
    return result;
  },
  GetIdMap = panelId => {
    return {
      accordion: (0, _string.isStringOfLength)(panelId) ? `id_${panelId}_accordion` : undefined,
      summary: (0, _string.isStringOfLength)(panelId) ? `id_${panelId}__accordion-summary` : undefined,
      details: (0, _string.isStringOfLength)(panelId) ? `id_${panelId}__accordion-details` : undefined
    };
  },
  HandleChange = (event, panel, action, dispatch, onChange) => {
    const actionType = action === "open" ? "open" : "close";
    let result = false;
    if ((0, _object.isObject)(event) && (0, _object.isObject)(event.target) && (0, _string.isStringOfLength)(event.target.nodeName) && event.target.nodeName.toLowerCase() === "a") {
      result = true;
    } else {
      if ((0, _string.isStringOfLength)(panel) && (0, _function.isFunction)(dispatch)) {
        dispatch({
          type: actionType,
          panelId: panel
        });
        result = panel;
      }
      if ((0, _function.isFunction)(onChange)) {
        onChange(event, panel);
      }
    }
    return result;
  },
  StateReducer = (state, action) => {
    let result;
    switch (action.type) {
      case "close":
        result = {
          ...state,
          defaultOpenPanelId: "",
          expandedIds: state.expandedIds.filter(panelId => panelId !== action.panelId)
        };
        break;
      case "default-panel":
        result = {
          ...state,
          defaultOpenPanelId: action.panelId
        };
        break;
      case "open":
        if (state.isAutoclose === true) {
          result = {
            ...state,
            defaultOpenPanelId: "",
            expandedIds: [action.panelId]
          };
        } else if (state.panelIdList.includes(action.panelId) && !state.expandedIds.includes(action.panelId)) {
          result = {
            ...state,
            defaultOpenPanelId: "",
            expandedIds: [...state.expandedIds, action.panelId]
          };
        } else {
          result = {
            ...state
          };
        }
        break;
      case "open_all":
        result = {
          ...state,
          defaultOpenPanelId: "",
          expandAll: false,
          expandedIds: [...state.panelIdList]
        };
        break;
      case "open_hash":
        if (state.isAutoclose === true) {
          result = {
            ...state,
            defaultOpenPanelId: "",
            expandedIds: [action.panelId]
          };
        } else if (state.panelIdList.includes(action.panelId) && !state.expandedIds.includes(action.panelId)) {
          result = {
            ...state,
            defaultOpenPanelId: "",
            expandedIds: [...state.expandedIds, action.panelId]
          };
        } else {
          result = {
            ...state
          };
        }
        break;
      default:
        result = {
          ...state
        };
        break;
    }
    return result;
  };

/**
 * Show/Hide Accordion List
 *
 * @visibleName Accordion
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
 * @example
 * Link opens a targeted accordion through url query has value referring to accordion id (derived from fragment id or custom id):
 * <pre>&lt;a href=&quot;location#id\_{fragmentId}\_accordion&quot;&gt;Link&lt;/a&gt;</pre>
*/
exports.StateReducer = StateReducer;
exports.HandleChange = HandleChange;
exports.GetIdMap = GetIdMap;
exports.ExtractPanelId = ExtractPanelId;
exports.DefaultStyles = DefaultStyles;
const Accordion = props => {
  const {
      children,
      className,
      customComponentMap = {},
      customTheme = {},
      disableAutoclose = true,
      disableClose = false,
      expandAll = false,
      fragmentArray,
      IconOpenComponent = _Add.default,
      IconCloseComponent = _Remove.default,
      onChange,
      openFragment = "",
      options = {},
      styles = {},
      testId
    } = props,
    DomOptions = merge(options, _common.DOM_PURIFY_OPTIONS),
    ComponentMap = merge({
      ImportedContentFragment: _ImportedContentFragment.default
    }, customComponentMap),
    isAutoClose = disableAutoclose === true ? false : true,
    panelList = (0, _array.isArrayOfLength)(fragmentArray) ? fragmentArray.map(item => AccordionMethods.ExtractPanelId(item)) : [],
    compiledClassnames = (0, _classnames.default)({
      "accordion": true,
      [`${className}`]: className
    }),
    theme = merge((0, _styles.useTheme)(), customTheme),
    [state, dispatch] = (0, _react.useReducer)(AccordionMethods.StateReducer, {
      defaultOpenPanelId: openFragment,
      disableClose: disableClose,
      expandAll: expandAll,
      expandedIds: [],
      panelIdList: panelList,
      isAutoclose: isAutoClose
    }),
    location = (0, _reactRouterDom.useLocation)(),
    accordionStyles = merge(DefaultStyles(theme), styles),
    transitionProps = {
      timeout: {
        enter: 500,
        exit: 500
      }
    },
    DisableIconComponent = state.disableClose ? "" : IconCloseComponent,
    handleChange = (e, panelId, action) => AccordionMethods.HandleChange(e, panelId, action, dispatch, onChange);
  (0, _react.useEffect)(() => {
    let replacedHash;

    /* If expand all is true, autoclose is disabled, and there are no expanded Ids,
    dispatch an action to open all the accordion panels */
    if (state.expandAll === true && disableAutoclose === true && state.expandedIds.length < 1) {
      dispatch({
        type: "open_all"
      });
    }
    /* If a hash exists and we have a valid array of panel ids, continue to find a matching panel  */else if ((0, _string.isStringOfLength)(location.hash) && (0, _array.isArrayOfLength)(state.panelIdList)) {
      /* Remove the leading "#" from the hash string
      then, if hash starts with _id, remove it
      lastly, if hash ends with _accordion, remove it */
      replacedHash = location.hash.substring(1).replace(/^id_/i, "");
      replacedHash = replacedHash.replace(/_accordion$/i, "");
      //  Keeping only valid ID characters, only alphanumeric, "-", "_", and "." allowed.
      replacedHash = replacedHash.replace(/[^a-z0-9_\-.:]/gi, "");

      /* If replacedHash exists in the panelIdList and NOT in the expandedIds list,
      	dispatch the action to open the panel using the replacedHash.*/
      if (state.panelIdList.includes(replacedHash) && !state.expandedIds.includes(replacedHash)) {
        dispatch({
          type: "open_hash",
          panelId: replacedHash,
          isHash: true
        });
      }

      /* Scroll to an element with the replacedHash in form id_${replacedHash}_accordion,
      if the replacedHash ===  original hash string without the "#"
      aka, didn't ever have id_ or _accordion in the hash string */
      if (replacedHash === location.hash.substring(1)) {
        const targetElem = document.getElementById(`id_${replacedHash}_accordion`);
        if (targetElem) {
          (0, _scroll.scrollToElement)(targetElem);
        }
      }
    } else if ((0, _string.isStringOfLength)(state.defaultOpenPanelId)) {
      dispatch({
        type: "open",
        panelId: state.defaultOpenPanelId
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disableAutoclose, location, state.expandAll, state.panelIdList, state.defaultOpenPanelId]);
  (0, _react.useEffect)(() => {
    dispatch({
      type: "default-panel",
      panelId: openFragment
    });
  }, [openFragment]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: compiledClassnames,
    component: "div",
    "data-testid": testId,
    sx: accordionStyles
  }, (0, _array.isArrayOfLength)(fragmentArray) && fragmentArray.map((panelObj, index) => {
    const {
        children,
        className,
        fragmentId,
        isAfterFragment,
        label,
        styles,
        content
      } = panelObj,
      panelId = AccordionMethods.ExtractPanelId(panelObj),
      isExpanded = state.expandedIds.includes(panelId),
      idMap = AccordionMethods.GetIdMap(panelId),
      compiledClassInstance = (0, _classnames.default)({
        ".accordion__panel": true,
        [`${className}`]: className
      });
    return /*#__PURE__*/_react.default.createElement(_material.Accordion, {
      className: compiledClassInstance,
      "data-testid": testId ? `${idMap.accordion}--${testId}` : undefined,
      expanded: isExpanded,
      id: idMap.accordion,
      onChange: e => handleChange(e, panelId, isExpanded && !state.disableClose ? "close" : "open"),
      key: `key_${idMap.accordion}_${index}`,
      slotProps: {
        transition: transitionProps
      },
      square: true,
      sx: styles
    }, /*#__PURE__*/_react.default.createElement(_material.AccordionSummary, {
      "aria-controls": idMap.details,
      expandIcon: isExpanded ? /*#__PURE__*/_react.default.createElement(DisableIconComponent, null) : /*#__PURE__*/_react.default.createElement(IconOpenComponent, null),
      id: idMap.summary
    }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
      className: "Accordion--isHeader",
      component: "div"
    }, label)), /*#__PURE__*/_react.default.createElement(_material.AccordionDetails, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
      className: "Accordion--isDetails"
    }, !isAfterFragment && children && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, children), (0, _string.isStringOfLength)(content) && (0, _string.isStringOfLength)(panelId) && /*#__PURE__*/_react.default.createElement(_material.Typography, {
      component: "div",
      dangerouslySetInnerHTML: {
        __html: _dompurify.default.sanitize(content, DomOptions)
      }
    }), !(0, _string.isStringOfLength)(content) && (0, _string.isStringOfLength)(fragmentId) && /*#__PURE__*/_react.default.createElement(ComponentMap.ImportedContentFragment, {
      customComponentMap: ComponentMap,
      id: fragmentId
    }), isAfterFragment && children && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, children))));
  }), children);
};

// Define propTypes;
Accordion.propTypes = {
  /** Child nodes containing custom content, appears after accordion */
  children: _propTypes.default.any,
  /** Optional custom component map for passing instance components */
  customComponentMap: _propTypes.default.objectOf(_propTypes.default.elementType),
  /** Material Theme object, for website theme injection (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** Boolean to enable/disable isAutoclose behavior (Default Value: true) */
  disableAutoclose: _propTypes.default.bool,
  /** @ignore */
  disableClose: _propTypes.default.bool,
  /** Boolean to open all panels (when accordion's isAutoclose is disabled) */
  expandAll: _propTypes.default.bool,
  /** Array of imported fragements, building each accordion item */
  fragmentArray: _propTypes.default.arrayOf(_propTypes.default.shape({
    /** Children node(s) to include in content */
    children: _propTypes.default.any,
    /** Class name(s) to include on each panel */
    className: _propTypes.default.string,
    /** Custom ID String to replace Fragment ID identifier */
    customId: _propTypes.default.string,
    /** Fragment ID of base content */
    fragmentId: _propTypes.default.string,
    /** Boolean to move children position after the fragment  */
    isAfterFragment: _propTypes.default.bool,
    /** Link ID String for panels to allow OPI to link to panels in fragments. */
    linkId: _propTypes.default.string,
    /** Label of open/hide button */
    label: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
    /** Styles object */
    styles: _propTypes.default.object
  })),
  /** Component icon for "click to open" state (Default Value: AddIcon MUI component) */
  IconOpenComponent: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.element, _propTypes.default.node, _propTypes.default.object]),
  /** Component icon for "click to close" state (Default Value: RemoveIcon MUI Component) */
  IconCloseComponent: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.element, _propTypes.default.node, _propTypes.default.object]),
  /** Method to handle button changes, uses AccordionMethods.HandleChange by default */
  onChange: _propTypes.default.func,
  /** String identifying label that is defaulting open, or false if none is open (Default Value: "") */
  openFragment: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
  /** DOM Purify Options */
  options: _propTypes.default.object,
  /** Custom style object, for customing CSS (in JSON style notation) (Default Value: {}) */
  styles: _propTypes.default.object,
  /** @ignore */
  testId: _propTypes.default.string
};

// Export component as default;
var _default = exports.default = Accordion;